export default __webpack_public_path__ + "static/media/Zahl-2.878a0be0.png";